import React, { useState, useEffect } from "react";
import { NavLink, useNavigate, useLocation } from "react-router-dom";
import styles from "./navbar.module.css";
import burgerMenu from "../../../../assests/navbar/burger.webp";
import menuClose from "../../../../assests/navbar/menu_close.png";
import logoGif from "../../../../assests/videos/BusinessCorners.gif";

function Navbar() {
  const [show, setShow] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const toggleMenu = () => setShow(!show);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    if (location.pathname !== "/") {
      navigate("/");
      setTimeout(() => {
        const section = document.getElementById(sectionId);
        if (section) {
          section.scrollIntoView({ behavior: "smooth" });
        }
      }, 300);
    } else {
      const section = document.getElementById(sectionId);
      if (section) {
        section.scrollIntoView({ behavior: "smooth" });
      }
    }
  };

  const aboutLink = () => scrollToSection("about");
  const teamLink = () => scrollToSection("team");
  const servicesLink = () => scrollToSection("services");
  const contactLink = () => scrollToSection("partner");

  return (
    <div
      className={`${styles.navbar_wrapper} ${scrolled ? styles.scrolled : ""}`}>
      <nav className={styles.navbar_container}>
        {/* Logo link to home */}
        <NavLink className={styles.logoWrapper} to="/">
          <img className={styles.logo} src={logoGif} alt="Logo Animation" />
        </NavLink>

        <ul className={`${styles.navlinks} ${show ? styles.show : ""}`}>
          {/* New Home Link */}
          <li>
            <NavLink className={styles.navlinksA} to="/">
              Home
            </NavLink>
          </li>
          <li>
            <NavLink onClick={aboutLink} className={styles.navlinksA} to="/">
              About
            </NavLink>
          </li>
          <li>
            <NavLink onClick={teamLink} className={styles.navlinksA} to="/">
              Team & Partners
            </NavLink>
          </li>
          <li>
            <NavLink onClick={servicesLink} className={styles.navlinksA} to="/">
              Services
            </NavLink>
          </li>
          <li>
            <NavLink onClick={contactLink} className={styles.navlinksA} to="/">
              Contact
            </NavLink>
          </li>
        </ul>

        <section className={styles.utilMenu}>
          <img
            className={styles.menuMobile}
            src={show ? menuClose : burgerMenu}
            alt="menu toggle"
            onClick={toggleMenu}
          />
        </section>
      </nav>
    </div>
  );
}

export default Navbar;
